"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.buttonLinkPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ButtonLink = function ButtonLink(_ref) {
  var text = _ref.text,
      url = _ref.url,
      className = _ref.className,
      icon = _ref.icon,
      size = _ref.size,
      rel = _ref.rel,
      target = _ref.target,
      type = _ref.type;
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    rel: rel,
    target: target,
    className: "button ".concat(type, " ").concat(size, " ").concat(className)
  }, text, icon);
};

var buttonLinkPropTypes = {
  text: _propTypes["default"].string.isRequired,
  url: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  icon: _propTypes["default"].node,
  rel: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  target: _propTypes["default"].oneOf(['_self', '_blank', '_parent', '_top']),
  type: _propTypes["default"].oneOf(['text', 'default', 'primary', 'secondary', 'clearButton'])
};
exports.buttonLinkPropTypes = buttonLinkPropTypes;
ButtonLink.propTypes = buttonLinkPropTypes;
ButtonLink.defaultProps = {
  className: '',
  icon: null,
  rel: undefined,
  size: 'medium',
  target: undefined,
  type: 'default'
};
var _default = ButtonLink;
exports["default"] = _default;